import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';

export const useQuery = () => {
  const { search } = useLocation();

  const parseProp = (propString = '') => {
    const [key, value] = propString.split('=');
    return {
      [key]: value,
    };
  };

  const getParams = () => {
    const search = window.location.search;
    return search
      .substring(1)
      .split('&')
      .map(parseProp)
      .reduce((prev, curr) => ({ ...prev, ...curr }), {});
  };

  const parsedProps = useMemo(() => search && getParams(), [search]);

  return parsedProps || {};
};
